var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPencil = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.70117 16.249H5.61784L14.847 7.01983L13.9303 6.10316L4.70117 15.3323V16.249ZM17.4928 6.12399L14.8262 3.45733L15.6975 2.58601C15.9361 2.34744 16.2324 2.23163 16.5866 2.23858C16.9408 2.24552 17.2359 2.36705 17.472 2.60316L18.3678 3.49899C18.604 3.7351 18.722 4.02677 18.722 4.37399C18.722 4.72121 18.6042 5.01262 18.3686 5.24822L17.4928 6.12399ZM4.08298 17.499C3.90397 17.499 3.75391 17.4385 3.63282 17.3175C3.51172 17.1964 3.45117 17.0464 3.45117 16.8675V15.0836C3.45117 14.9994 3.46506 14.9226 3.49284 14.8532C3.52062 14.7837 3.56923 14.7143 3.63867 14.6448L13.9512 4.33233L16.6178 6.99899L6.30534 17.3115C6.23589 17.3809 6.16494 17.4295 6.09248 17.4573C6.02001 17.4851 5.94513 17.499 5.86784 17.499H4.08298ZM14.3887 6.56149L13.9303 6.10316L14.847 7.01983L14.3887 6.56149Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPencil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pencil.ea398a88a238e9efd507df09c88728db.svg";